<tiime-dialog [isLoading]="isLoading()" (cancel)="cancel()">
  <div mat-dialog-title>{{ hasSelectedDocuments ? 'Importer les documents sélectionnés' : 'Ajouter un document' }}</div>
  <mat-dialog-content class="dialog-content" mat-dialog-content data-cy="upload-document-dialog">
    <app-document-category-select
      [documentCategories]="documentCategories$ | async | map: mapToAvailableDocumentCategories"
      [documentCategoryControl]="documentCategoryFilter"
      [errorMessage]="documentCategoryErrorMessage"
      [displayMenu]="false"
      (createdDocumentCategory)="createdDocumentCategory($event)"
    ></app-document-category-select>
    @if (selectedDocuments?.length > 0) {
      <div class="document-list">
        <strong>Documents sélectionnées</strong>
        @for (file of selectedDocuments; track $index) {
          <app-simple-cell [value]="file.name" />
        }
      </div>
    }
  </mat-dialog-content>
  <mat-dialog-actions class="dialog-actions">
    <button data-cy="upload-document-dialog-cancel-btn" tiime-button color="accent" strocked large (click)="cancel()">
      Annuler
    </button>
    <button
      data-cy="upload-document-dialog-import-btn"
      tiime-button
      large
      color="accent"
      raised
      (click)="uploadFiles()"
    >
      Importer des documents
    </button>
  </mat-dialog-actions>
</tiime-dialog>
<input
  hidden
  #fileInput
  id="file"
  type="file"
  [accept]="acceptedTypes"
  (change)="onFileSelected(fileInput.files)"
  multiple
  data-cy="upload-document-dialog-file-input"
/>
